












































# import settings from '@/settings'
import interviews_table from '@/components/tables/interviews_table'
import interview_files_modal from '@/components/interview_files_modal'
import n from '@/utils/notifications'
import t from '@/utils/tools'
import q from '@/graphql/query'
import m from '@/graphql/mutation'

export default {
    name: 'users_interviews_requests'

    components: { interviews_table, interview_files_modal }

    data: ()->
        dialog_visible: false
        reload: true
        errors: {}
        active_names: [1]
        interview_choice_set: []
        readonly: false
        clearable: false
        picker_options: {firstDayOfWeek:1}
        false: false
        app_users: []
        interview: {
            uid: ''
            asked_user_uid: ''
            interview_type: {uid:''}
            datetime: ''
            state: {uid:''}
            reason: ''
        }

    computed:
        save_text: ()->
            text = "Ajouter"
            if @interview.uid != ''
                text = "Enregistrer"
            return text

        toggle_collapse_text: ()->
            text = "Ajouter une demande d'entretien"
            if @active_names.length > 1
                text = "Fermer"
            return text

        toggle_collapse_icon: ()->
            class_icon = 'mdi-plus-circle-o'
            if @active_names.length > 1
                class_icon = 'mdi-close-circle-o'
            return class_icon

    methods:
        has_access_right: t.has_access_right

        reset_interview: ()->
            # console.log "RESET INTERVIEW ", typeof(@app_users)
            # console.log "RESET INTERVIEW ", @app_users[0]
            asked_user_uid = ''
            if @app_users.length > 0
                asked_user_uid = @app_users[0].uid
            @interview = {
                uid: ''
                asked_user_uid: asked_user_uid
                interview_type: t.deep_copy(@interview_choice_set[0])
                datetime: ''
                state: {uid:''}
                reason: ''
            }
            return

        get_errors: (fieldName)->
            ret = null
            if @errors[fieldName]?
                ret = @errors[fieldName][0]
            return ret

        collapse_change: (value)->
            # console.log "VUE TOGGLE ", value
            @errors = {}
            @reset_interview()
            return

        edit_interview: (interview)->
            # console.log "EDIT INTERVIEW ", interview
            @interview = t.deep_copy(interview)
            @interview.asked_user_uid = interview.asked_user_uid
            @active_names = [1, "1"]
            @$root.$el.scrollTop = 0
            @errors = {}
            return

        delete_interview: (interview_uid)->
            # console.log  "DELETE INTERVIEW", interview_uid
            self = @
            @$confirm("Êtes-vous sûr·e de vouloir supprimer cette demande d'entretien ?", 'Confirmation', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler'
                })
                .then ()->
                    # console.log "INTERVIEW DELETE", interview_uid
                    m.run('delete_object', ['interview', interview_uid])
                    .then (resp)->
                        # console.log "DELETE INTERVIEW", resp.body.data.interview_deletion
                        if resp.body.data.interview_deletion.ok
                            n.success()
                            self.reload = !self.reload
                        else
                            n.gql_error("users_interviews_requests: delete_interview: then", resp.body.data.interview_deletion.message)
                    .catch (resp)->
                        n.catch_error(resp, "users_interviews_requests: delete_interview()")
                .catch (cancel)->
                    return

        open_file_modal: (interview)->
            # console.log "UIR -> OPEN"
            @interview = interview
            @dialog_visible = true
            return

        close_file_modal: ()->
            # console.log "UIR -> CLOSE"
            @dialog_visible = false
            @reload = !@reload
            return

        get_app_users: ()->
            self = @
            q.run('get_interviews_requests_app_user_set', [])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("users_interviews_requests: get_app_users: then", e.message)
                else
                    # console.log "GET APP USERS : ", resp.body.data.interviews_requests_app_user_set
                    if resp.body.data.interviews_requests_app_user_set.length > 0
                        self.app_users = resp.body.data.interviews_requests_app_user_set
                        self.interview.asked_user_uid = resp.body.data.interviews_requests_app_user_set[0].uid
                        self.app_users = self.app_users.filter (x)->
                            x.uid != self.$store.state.user_datas.app_user.uid
            .catch (resp)->
                n.catch_error(resp, "users_interviews_requests: get_app_users()")

        save: ()->
            # console.log "SAVE INTERVIEW", @interview
            self = @
            m.run('save_interview', [@interview, 'users'])
            .then (resp)->
                if resp.body.data.interview_form_mutation.form_ret == 'failed'
                    return n.access_denied()
                if resp.body.data.interview_form_mutation.errors.length > 0
                    # console.log "ERRORS", resp.body.data.interview_form_mutation.errors
                    self.errors = resp.body.data.interview_form_mutation.errors.reduce(
                        (acc, el)->
                            acc[el.field] = el.messages
                            return acc
                    ,{})
                    n.form_error()
                else
                    self.errors = {}
                    n.success()
                    self.reset_interview()
                    self.active_names = [1]
                    self.reload = !self.reload
            .catch (resp)->
                n.catch_error(resp, "users_interviews_requests: save()")

        get_interview_choice_set: ()->
            self = @
            q.run('get_type_set', ['interview_choice'])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("users_interviews_requests: get_interview_choice_set: then" ,e.message)
                else
                    # console.log "GET INTERVIEW TYPE CHOICES : ", resp.body.data.interview_choice_set
                    self.interview_choice_set = resp.body.data.interview_choice_set
            .catch (resp)->
                n.catch_error(resp, "users_interviews_requests: get_interview_choice_set()")

    beforeMount: ()->
        @get_app_users()
        @get_interview_choice_set()
}
